import React, { Fragment, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import lightBlue from '@material-ui/core/colors/lightBlue';
import red from '@material-ui/core/colors/red';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Snackbar, Button } from '@material-ui/core';
import Navbar from '../../components/Navbar';
import Header from '../../components/Header';
import Login from '../../components/Login';
import parseToken from '../../helpers/parseToken';
import AlertCC from '../../components/AlertCertificadoCirculacion';
import moment from 'moment';

import { useSelector, useDispatch } from 'react-redux';
import { renovarSesion, logout, setExpirando } from '../../redux/actions/authActions';
import SnackbarContent from '@material-ui/core/SnackbarContent';

const useStyles = makeStyles((theme) => ({
  snackbar: {
    'margin-bottom': 70,
  },
}));

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#01579b',
    },
    secondary: lightBlue,
    danger: red,
  },
});

let logoutTimeout = null;
let logoutAlertTimeout = null;

const Home = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { usuario, token, permisoCC, esencialCC, reestriccionCC } = useSelector(
    (state) => state.auth
  );
  const open = useSelector((state) => state.auth.expirando);

  const handleExtenderSesion = () => {
    dispatch(renovarSesion(token));
  };

  useEffect(() => {
    //console.log("Limpiando timeout");

    clearTimeout(logoutTimeout);
    clearTimeout(logoutAlertTimeout);

    if (token !== null) {
      // console.log("Programando expiración...");
      const decode = parseToken(token);

      const unixTimestamp = localStorage.getItem('lastLogin');
      const lastLogin = moment.unix(unixTimestamp);

      const restantes = decode.expMillis - moment().diff(lastLogin, 'milliseconds');

      console.log(`Expiración: ${moment().add(restantes, 'milliseconds').toISOString()}`);

      if (restantes <= 0) {
        dispatch(logout());
      } else {
        // Deslogueo al expirar el token
        logoutTimeout = setTimeout(() => {
          console.log('Deslogueando por expiración de sesión');
          dispatch(logout());
        }, restantes);

        // Muestro alerta 30 segundos antes
        logoutAlertTimeout = setTimeout(() => {
          console.log('Mostrando alerta');
          dispatch(setExpirando());
        }, restantes - 30 * 1000);
      }
    }
  }, [token, dispatch]);

  return (
    <MuiThemeProvider theme={theme}>
      <Fragment>
        <Login />
        <Header />
        {usuario ? (
          <AlertCC
            permisoCC={permisoCC}
            esencialCC={esencialCC}
            reestriccionCC={reestriccionCC}
          />
        ) : null}
        {usuario ? <Navbar /> : null}
        <Snackbar
          open={open}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          className={classes.snackbar}
        >
          <SnackbarContent
            message='Tu sesión esta a punto de finalizar ¿Seguís ahí?'
            action={
              <Button color='secondary' size='small' onClick={handleExtenderSesion}>
                Extender sesión
              </Button>
            }
          />
        </Snackbar>
      </Fragment>
    </MuiThemeProvider>
  );
};

export default Home;
